export interface IAboutTextEditor {
    title: { [key: string]: string };
    content: { [key: string]: string };
}
